import React from 'react';

import Click2PayInfoReview from '@pages/click2pay/onboarding/Click2PayInfoReview/Click2PayInfoReview';

const Click2PayInfoReviewPage = () => {
    return (
        <>
            <h3>Gjennomgå informasjonen din</h3>
            <p>For at alt skal fungere som det skal, må du sjekke at informasjonen vi har på deg er oppdatert</p>
            <Click2PayInfoReview />
        </>
    );
};

export default Click2PayInfoReviewPage;
